// Human-readable labels for the group module
export const LEGAL_FORM_LABELS = {
  HOLDING: "Holding",
  SCI_IS: "SCI à l'IS",
  SCI_IR: "SCI à l'IR",
  SAS: "SAS",
  SASU: "SASU",
  SARL: "SARL",
  EURL: "EURL",
  ENTREPRISE_INDIVIDUELLE: "Entreprise individuelle",
  INDIVISION: "Indivision",
  PERSONNE_PHYSIQUE: "Personne physique",
  ASSOCIATION: "Association",
  AUTRE: "Autre",
};

export const TAX_REGIME_LABELS = {
  IS: "Impôt sur les sociétés",
  IR: "Impôt sur le revenu",
  MICRO: "Micro-entreprise",
  EXO: "Exonéré",
  "N/A": "Non applicable",
};

export const VAT_PERIODICITY_LABELS = {
  mensuelle: "Mensuelle",
  trimestrielle: "Trimestrielle",
  annuelle: "Annuelle",
  franchise: "Franchise en base",
  "n/a": "Non applicable",
};

export const STATUS_LABELS = {
  active: "Active",
  inactive: "Inactive",
  archived: "Archivée",
};

export const MANAGEMENT_MODE_LABELS = {
  full: "Gestion complète",
  reference: "Référence uniquement",
};

export const FLOW_NATURE_LABELS = {
  dividende: "Dividende",
  cca_avance: "Avance en compte courant",
  cca_remboursement: "Remboursement compte courant",
  pret_intragroupe: "Prêt intragroupe",
  apport_capital: "Apport en capital",
  management_fees: "Management fees",
  loyer_intragroupe: "Loyer intragroupe",
  autre: "Autre",
};

export const FLOW_STATUS_LABELS = {
  planned: "Prévu",
  validated: "Validé",
  realized: "Réalisé",
};

export const HOLDER_TYPE_LABELS = {
  person: "Personne physique",
  company: "Société du groupe",
  external: "Tiers externe",
};

// Visual accent per legal form
export const LEGAL_FORM_TONES = {
  HOLDING: { bg: "bg-accent/15", text: "text-accent", border: "border-accent/40" },
  SCI_IS: { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200" },
  SCI_IR: { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200" },
  SAS: { bg: "bg-sky-50", text: "text-sky-800", border: "border-sky-200" },
  SASU: { bg: "bg-sky-50", text: "text-sky-800", border: "border-sky-200" },
  SARL: { bg: "bg-indigo-50", text: "text-indigo-800", border: "border-indigo-200" },
  EURL: { bg: "bg-indigo-50", text: "text-indigo-800", border: "border-indigo-200" },
  DEFAULT: { bg: "bg-secondary", text: "text-secondary-foreground", border: "border-border" },
};

export function getLegalFormTone(form) {
  return LEGAL_FORM_TONES[form] || LEGAL_FORM_TONES.DEFAULT;
}
